import styled from 'styled-components';
import { StyledContainer } from '../../../tableItemDetailViewComponents/Containers';

export const StyledIframe = styled.iframe`
  border: 1px solid var(--grayscale-100);
  border-radius: var(--border-radius-medium);
  min-height: 1000px;
  height: 100%;
  width: 100%;
  overflow-y: hidden;
`;

export const FormActionContainer = styled(StyledContainer)`
  box-sizing: border-box;
  padding: 16px;
  width: 100%;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  align-self: center;
  position: relative;
`;

export const StickyButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  background: var(--white);
  padding: 16px;
  border-top: 1px solid var(--grayscale-100);
  // bottom border radius
  border-radius: 0 0 var(--border-radius-medium) var(--border-radius-medium);
  // so that the container stretches the full width of the outer form action container
  margin: 0 -16px;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const RadioLabelAndSubheader = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const RadioOptionWithSubheader = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const RadioOptionWithSubheaderWrapper = styled.div`
  // Override align-items: center from RadioOption to align with top (label)
  > label,
  label {
    align-items: flex-start !important;
    padding: 12px;
  }
`;

export const FLOATING_BUTTON_TOP_OFFSET = '-90px';
export const FLOATING_BUTTON_RIGHT_OFFSET = '32px';
